import { render, staticRenderFns } from "./WithdrawalCenter.vue?vue&type=template&id=6dc7ddb3&scoped=true&"
import script from "./WithdrawalCenter.vue?vue&type=script&lang=js&"
export * from "./WithdrawalCenter.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalCenter.vue?vue&type=style&index=0&id=6dc7ddb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7ddb3",
  null
  
)

export default component.exports